/* eslint-disable @typescript-eslint/no-magic-numbers */
import * as Sentry from '@sentry/react';
import React from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import { getVersion } from 'utils';

export default function initSentry() {
  if (import.meta.env.VITE_ENABLE_SENTRY !== 'true') {
    console.log('Sentry is not enabled');
    return;
  }

  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN as string,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      Sentry.browserProfilingIntegration(),
      Sentry.captureConsoleIntegration({ levels: ['error', 'warn', 'log'] }),
      Sentry.contextLinesIntegration(),
      Sentry.extraErrorDataIntegration(),
      Sentry.httpClientIntegration(),
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    sendDefaultPii: true,
    release: getVersion(),
    environment: import.meta.env.VITE_ENVIRONMENT as string,
    // tracesSampler: ({ name, parentSampled }) => {
    //   console.log('name is', name);
    //   // Exclude transactions for static assets
    //   const excludedPatterns = [
    //     /\.(png|jpe?g|svg|ico|webp|gif)$/i, // Image files
    //     /\.(css|map)$/i, // CSS, JS, and source maps
    //     /\.(woff|woff2|ttf|eot)$/i, // Fonts
    //   ];

    //   if (excludedPatterns.some((pattern) => pattern.test(name || ''))) {
    //     return 0; // Exclude this transaction
    //   }
    //   if (typeof parentSampled === 'boolean') {
    //     return parentSampled;
    //   }

    //   // Default sampling rate for other transactions
    //   return 1; // Adjust based on your needs
    // },
    // Tracing
    tracesSampleRate: 1, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [/^https:\/\/v1-api\.swiftpal\.ai.*/],
    // Session Replay
    replaysSessionSampleRate: 0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}
